var map = {
	"./en/common.json": 3147,
	"./en/message.json": 1292,
	"./en/views/login.json": 5466,
	"./ko/common.json": 7629,
	"./ko/message.json": 4472,
	"./ko/views/form.json": 1965,
	"./ko/views/list.json": 7775,
	"./ko/views/login.json": 348,
	"./ko/views/popup.json": 8344,
	"./ko/views/register.json": 2383,
	"./ko/views/statistics.json": 5149,
	"./ko/views/terms.json": 3706,
	"./vi/common.json": 5972,
	"./vi/message.json": 6521,
	"./vi/views/form.json": 5517,
	"./vi/views/list.json": 5937,
	"./vi/views/login.json": 3271,
	"./vi/views/popup.json": 3154,
	"./vi/views/register.json": 2178,
	"./vi/views/statistics.json": 902,
	"./vi/views/terms.json": 2410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4142;